import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const EpButton = ({
  labelText, buttonIcon, customClass, disabled, actionType, buttonType, buttonId, dataBsToggle,
  ariaExpanded, autoClose, linkFunc, isActive, size, dataBsTarget, ariaControls,
  //
}) => (
  <button aria-controls={ariaControls} data-bs-target={dataBsTarget} onClick={linkFunc} type={actionType} className={`btn btn--${buttonType} ${customClass} ${size ? ` btn--${size} ` : ''}${isActive ? `btn--${buttonType}--active` : ''}`} disabled={disabled} id={buttonId} data-bs-toggle={dataBsToggle} aria-expanded={ariaExpanded} data-bs-auto-close={autoClose}>
    {buttonIcon}
    {labelText !== '' && <span>{labelText}</span>}
  </button>
);

export default EpButton;

EpButton.defaultProps = {
  labelText: '',
  buttonType: '',
  ariaExpanded: 'false',
  autoClose: 'true',
  dataBsToggle: '',
  customClass: '',
  buttonIcon: null,
  disabled: false,
  buttonId: null,
  linkFunc: null,
  isActive: false,
  size: 'md',
  dataBsTarget: '',
  ariaControls: '',
  actionType: 'button',
};

EpButton.propTypes = {
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actionType: PropTypes.oneOf(['submit', 'button', 'reset']),
  buttonType: PropTypes.string,
  buttonId: PropTypes.string,
  customClass: PropTypes.string,
  buttonIcon: PropTypes.element,
  disabled: PropTypes.bool,
  dataBsToggle: PropTypes.string,
  ariaExpanded: PropTypes.string,
  autoClose: PropTypes.string,
  linkFunc: PropTypes.func,
  isActive: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  dataBsTarget: PropTypes.string,
  ariaControls: PropTypes.string,
};
